"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_BASE_BASE_TOKEN_DEFAULTS = void 0;
/**
 * Complete `--sl-app-*` base token defaults for the AppBase scope.
 *
 * Single source of truth consumed by every surface that renders AppBase
 * components outside an active ThemeRow:
 *
 *   - The standalone custom-app-viewer bundle mirrors these values in its
 *     static `theme.css` — kept in sync by
 *     `custom-app-viewer/src/__tests__/app-base-layout-contract.spec.ts`.
 *
 * Values match the `normal` spacing density and 16px base font size of a
 * default ThemeConfig, so a site without a theme row renders identically to
 * one with the untouched default theme.
 */
exports.APP_BASE_BASE_TOKEN_DEFAULTS = {
    '--sl-app-card-gap': '16px',
    '--sl-app-card-padding': '16px',
    '--sl-app-card-radius': '8px',
    '--sl-app-hero-height': '360px',
    '--sl-app-hero-padding': '48px',
    '--sl-app-nav-width': '240px',
    '--sl-app-content-max-width': '1200px',
    '--sl-app-entry-padding': '24px',
    '--sl-app-tag-radius': '6px',
    '--sl-app-tag-padding': '2px 8px',
    '--sl-app-form-field-gap': '12px',
    '--sl-app-form-field-padding': '10px',
    '--sl-app-gap-xxs': '2px',
    '--sl-app-gap-xs': '4px',
    '--sl-app-gap-sm': '8px',
    '--sl-app-gap-md': '16px',
    '--sl-app-gap-lg': '24px',
    '--sl-app-padding-sm': '8px',
    '--sl-app-padding-md': '16px',
    '--sl-app-padding-lg': '24px',
    '--sl-app-padding-xl': '32px',
    '--sl-app-radius-xs': '2px',
    '--sl-app-radius-sm': '4px',
    '--sl-app-radius-md': '8px',
    '--sl-app-radius-pill': '999px',
    '--sl-app-font-size-xs': '12px',
    '--sl-app-font-size-sm': '14px',
    '--sl-app-font-size-md': '16px',
    '--sl-app-font-size-lg': '18px',
    '--sl-app-font-size-xl': '24px',
    '--sl-app-font-size-display': '36px',
    '--sl-app-shadow-sm': '0 2px 8px rgba(10, 10, 10, 0.08)',
    '--sl-app-shadow-md': '0 8px 24px rgba(10, 10, 10, 0.10)',
    '--sl-app-overlay-scrim': 'linear-gradient(to top, rgba(10, 10, 10, 0.55) 0%, rgba(10, 10, 10, 0.15) 60%, transparent 100%)',
    '--sl-app-contrast-text-color': '#ffffff',
    '--sl-app-tag-bg': 'rgba(80, 144, 211, 0.08)',
    '--sl-app-tag-border': 'rgba(80, 144, 211, 0.40)',
    '--sl-app-tag-text': '#3a7bbf',
    '--sl-app-layout-min-height': '200px',
    '--sl-app-form-max-width': '600px',
    '--sl-app-row-cover-max-height': '400px',
    '--sl-app-textarea-min-height': '80px',
    '--sl-app-article-thumbnail-width': '160px',
    '--sl-app-article-thumbnail-height': '100px',
    '--sl-app-article-thumbnail-mobile-height': '180px',
    '--sl-app-filter-min-width': '120px',
    '--sl-app-full-height': '100%',
    '--sl-app-full-width': '100%',
    '--sl-app-zero': '0',
    '--sl-app-markdown-heading-margin-start': '1.5em',
    '--sl-app-markdown-heading-margin-end': '0.5em',
    '--sl-app-markdown-list-padding': '1.5em',
    '--sl-app-markdown-block-margin': '0.75em 0',
    '--sl-app-markdown-tight-margin': '0.25em 0',
    '--sl-app-markdown-section-margin': '1em 0',
    '--sl-app-markdown-divider-margin': '1.5em 0',
};
